exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-ae547bbc] {\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.256px;\n}\n.text-bold[data-v-ae547bbc] {\n  font-weight: 700;\n}\n[data-v-ae547bbc] .button {\n  display: block;\n  margin: 40px auto 0;\n}\n", ""]);

// exports
